<template>
  <div class="compose-size-manage">
    <div class="breadcrumb" style="background: #fff">合成尺寸管理</div>
    <div class="third-title"> 基础设置</div>
    <div class="order-detail-basic">
      <div style="padding:0 100px;box-sizing: border-box">
        <div style="margin-bottom: 20px;">
          <span>合成尺寸:</span>
          <el-select v-model="composeType" placeholder="请选择" style="margin: 0 20px" @change="changeType">
            <el-option :label="item.typeName" :value="item.id" v-for="item in composeTypeList" :key="item.id"></el-option>
          </el-select>
          <el-button round type="primary" @click="addTable">添加</el-button>
        </div>
        <div v-if="tableList.length > 0">
          <el-table :data="tableList" border :row-class-name="rowClassName">
            <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
            <el-table-column label="尺寸类型" prop="composeName"></el-table-column>
            <el-table-column label="规格" prop="">
              <template v-slot="scope">
                宽度:{{ scope.row.sizeWidth }}mm
                高度:{{ scope.row.sizeHeight }}mm
              </template>
            </el-table-column>
            <el-table-column label="出血类型">
              <template v-slot="scope">
                {{ scope.row.bleed.bleedName }}
              </template>
            </el-table-column>
            <el-table-column label="出血" prop="">
              <template v-slot="scope">
                上方:{{ scope.row.bleed.bleedTop }}mm
                下方:{{ scope.row.bleed.bleedBottom }}mm
                内侧:{{ scope.row.bleed.bleedIn }}mm
                外侧:{{ scope.row.bleed.bleedOut }}mm
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <span class="color-blue" @click="deleteCompose(scope.row.index)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="confirm">确定</el-button>
    </div>

    <CombinedDialog ref="dialogRef" @selectComposeType="select"></CombinedDialog>

  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { composeTypeList, bleedDetail } from '@/api/pms'
export default {
  name: 'compose-size-manage',
  components: {
    CombinedDialog
  },
  data () {
    return {
      composeTypeList: [],
      composeType: '',
      tableList: [],
      selectedList: [],
      selectedWorkName: {}
    }
  },
  created () {
    composeTypeList().then((res) => {
      if (res.data.success) {
        this.composeTypeList = res.data.data
      }
    })
    let arr = JSON.parse(this.$route.query.composeSizeList)
    if (arr.length > 0) {
      this.tableList = arr
    }
  },
  methods: {
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    async getBleed (id) {
      let post = () => {
        return new Promise(resolve => {
          bleedDetail().then((res) => {
            if (res.data.success) {
              resolve(res.data.data)
            }
          })
        })
      }
      let result = await post()
      return result
    },
    changeType (data) {
      this.selectedWorkName = this.composeTypeList.find((item) => { // 这里的sampleTheme就是上面遍历的数据源
        return item.id === data
        // 筛选出匹配数据，是对应数据的整个对象
      })
    },
    addTable () {
      if (this.composeType === '') {
        this.$message.warning('请选择合成尺寸类型')
        return false
      }
      this.$refs.dialogRef.show('selectComposeSize', '选择尺寸', this.composeType, '', '', this.selectedWorkName.typeName)
      this.composeType = ''
    },
    select (val) {
      this.tableList = val
    },
    confirm () {
      if (this.tableList.length !== 2) {
        this.$message.warning('请选择合成尺寸')
        return false
      }
      let list = []
      this.tableList.forEach((item) => {
        list.push(item.id)
      })
      this.$router.push({
        path: './createnewsku2',
        query: {
          skuList: this.$route.query.skuList,
          composeSizeSet: JSON.stringify(list),
          index: this.$route.query.index,
          composeSizeList: JSON.stringify(this.tableList)
        }
      })
    },
    deleteCompose (index) {
      this.tableList.splice(index, 1)
    }
  }
}
</script>
 <style scoped>
</style>
